// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5b08666f","479":"a75b8ecd","941":"569b4e30"}[chunkId] + ".chunk.js";
};